import {
  SiFramer,
  SiGithub,
  SiNextdotjs,
  SiReact,
  SiTailwindcss,
  SiTypescript,
  SiSanity,
  SiFigma,
} from "react-icons/si";
import { IconType } from "react-icons";

export type ProjectProps = {
  id: number;
  name: string;
  description: string;
  technologies: IconType[];
  techNames: string[];
  techLinks: string[];
  github?: string;
  demo?: string;
  image: string;
  available: boolean;
};

export const projects = [
  {
    id: 0,
    name: "Janeth Orji",
    description:
      "A client Blog/Coaching website for her branding and coaching services with great visibility and good SEO.",
    technologies: [
      SiTypescript,
      SiSanity,
      SiNextdotjs,
      SiTailwindcss,
      SiFramer,
    ],
    techNames: [
      "TypeScript",
      "Sanity",
      "Next.js",
      "Tailwind CSS",
      "Framer Motion",
    ],
    techLinks: [
      "https://www.typescriptlang.org/",
      "https://www.sanity.io/",
      "https://nextjs.org/",
      "https://tailwindcss.com/",
      "https://www.framer.com/motion/",
    ],
    github: "",
    demo: "https://www.janethorji.com/",
    image: "/projects/janeth.png",
    available: true,
  },
  {
    id: 1,
    name: "NITEN",
    description:
      "A Digital Solution website for a company that offers various services to clients in the technology sector.",
    technologies: [SiTypescript, SiReact],
    techNames: ["Typescript", "React"],
    techLinks: ["https://www.typescriptlang.org/", "https://reactjs.org/"],
    github: "",
    demo: "https://niten.dev/",
    image: "/projects/niten.png",
    available: true,
  },
  {
    id: 2,
    name: "NIVEO",
    description:
      "A digital signage company website it will be going to prod soon , this is just a preview will update the link later. One of my best piece of art . LOve it . its a big project that has a dashboard , currently working on it and will update you when its done",
    technologies: [SiTypescript, SiReact, SiTailwindcss],
    techNames: ["Typescript", "React", "Tailwind CSS"],
    techLinks: [
      "https://www.typescriptlang.org/",
      "https://reactjs.org/",
      "https://tailwindcss.com/",
    ],
    github: "",
    demo: "https://niveo-teal.vercel.app/",
    image: "/projects/niveo.png",
    available: true,
  },
  {
    id: 3,
    name: "EGAA School",
    description:
      "A website made for a bilingual school , not published yet cause i was asked to make a more matured version but i though i would drop the first version here.",
    technologies: [SiTypescript, SiReact, SiTailwindcss],
    techNames: ["Typescript", "React", "Tailwind CSS"],
    techLinks: [
      "https://www.typescriptlang.org/",
      "https://reactjs.org/",
      "https://tailwindcss.com/",
    ],
    github: "",
    demo: "https://egaa.vercel.app/",
    image: "/projects/egaa.png",
    available: true,
  },
  {
    id: 4,
    name: "GIA Academy",
    description:
      "This is the matured version i am talking about . Its currently live . Didn't work on this one alone . Collaborated with www.github.com/nafis589.",
    technologies: [SiTypescript, SiReact, SiTailwindcss],
    techNames: ["Typescript", "React", "Tailwind CSS"],
    techLinks: [
      "https://www.typescriptlang.org/",
      "https://reactjs.org/",
      "https://tailwindcss.com/",
    ],
    github: "",
    demo: "https://godisalive.academy/en",
    image: "/projects/gia.png",
    available: true,
  },
  {
    id: 5,
    name: " Sun Design",
    description:
      " Not really a big project but just a hero section i designed for fun . The link there should redirect you to a figma page where i get websites design inspirations.",
    technologies: [SiFigma, SiReact],
    techNames: ["Figma", "React"],
    techLinks: ["https://www.figma.com/", "https://reactjs.org/"],
    github: "https://github.com/Elitesun/SunDesign",
    demo: "https://sun-design.vercel.app/",
    image: "/projects/sundesign.png",
    available: true,
  },

  {
    id: 6,
    name: "Templated Aviation Website",
    description: "An Aviation website for flight booking ",
    technologies: [SiTypescript, SiReact, SiTailwindcss],
    techNames: ["Typescript", "React", "Tailwind CSS"],
    techLinks: [
      "https://www.typescriptlang.org/",
      "https://reactjs.org/",
      "https://tailwindcss.com/",
    ],
    github: "",
    demo: "https://uixshuvo.vercel.app/",
    image: "/projects/aviation.png",
    available: true,
  },
  {
    id: 7,
    name: "Templated Crypto Website",
    description:
      "If you were to build a fintech will you go for this kind of design ? Was built to act like a template ",
    technologies: [SiTypescript, SiReact, SiTailwindcss],
    techNames: ["Typescript", "React", "Tailwind CSS"],
    techLinks: [
      "https://www.typescriptlang.org/",
      "https://reactjs.org/",
      "https://tailwindcss.com/",
    ],
    github: "",
    demo: "https://invest-brown-theta.vercel.app/",
    image: "/projects/crypto.png",
    available: true,
  },
];
